<template>
  <div>
  <pdf
    v-if="src"
    :src="src"
    :page="page"
    :rotate="debug ? 90 : 0"
    style="width: 100%"
    @error="errorPDF"
  />
  <v-container
      grid-list-md
      text-xs-center
      style="padding: 0px;"
    >
      <v-layout
        row
        wrap
      >
        <v-flex
          v-if="numPages > 1"
          xs12
          style="margin-bottom:20px;margin-top:20px;"
        >
          <v-card
            :style="{ 'color': Color.concat(' !important'), 'background-color': BGColor.concat(' !important') }"
            dark
            style="width:200px;margin:auto;opacity:0.8;"
          >
            <v-layout
              align-center
              justify-center
            >
              <v-icon
                class="mr-1"
                @click="() => handleChangePage(-1)"
              >
                mdi-arrow-left-bold-circle
              </v-icon>
              <span
                class="subheading mr-2"
                style="padding: 10px;"
              >
                {{ sPage }}
              </span>
              <v-icon
                class="mr-1"
                @click="() => handleChangePage(1)"
              >
                mdi-arrow-right-bold-circle
              </v-icon>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <center v-if="data.DownloadPdf"><v-btn text @click="handleDownloadPDF" :color="customTextColorContent ? customTextColorContent : ColorContent">{{$t('common.download')}}</v-btn></center>
  </div>
</template>

<script>
  import {
    mapState
  } from 'vuex'
  import utils from '@/services/utils'
  import pdf from 'vue-pdf'
  // const demo = require('@/assets/demo.pdf')
  export default {
    components: {
      pdf
    },
    props: {
      data: {
        type: Object,
        required: true,
        default: null
      },
      customTextColorContent: {
        type: String,
        required: false,
        default: null
      },
    },
    data: () => ({
      utl: null,
      src: null,
      page: 1,
      numPages: null
    }),
    computed: {
      ...mapState('app',['locale', 'FontContent', 'FontSizeContent', 'ColorContent', 'Color', 'BGColor']),
      sPage () {
        return `${utils.pad(this.page.toString(), this.numPages.toString().length)} / ${utils.pad(this.numPages.toString(), this.numPages.toString().length)}`
      },
      debug () {
        return this.$route.query.debug && this.$route.query.debug.length > 0
      }
    },
    watch: {
      'data.URL': {
        handler: function (newValue) {
          this.loadPDF(this.prepareURL(newValue))
        },
        deep: true
      },
    },
    mounted() {
      if (this.data.URL) this.loadPDF(this.prepareURL(this.data.URL))
    },
    methods: {
      errorPDF (error) {
        console.log(error)
      },
      loadPDF (value) {
        console.log('loadpdf', value)
        this.src = pdf.createLoadingTask(`${value}`)
        this.src.then(pdf => {
          console.log('pdf', pdf)
          this.numPages = pdf.numPages
          this.page = 1
        })
      },
      prepareURL (url) {
        this.url = url
        return url
      },
      handleChangePage (value) {
        this.page = (this.page + value) > 0 && (this.page + value) <= this.numPages ? this.page + value : this.page
      },
      handleDownloadPDF () {
        axios({
          method: 'get',
          url: this.url,
          responseType: 'arraybuffer'
        })
        .then(response => {
          this.forceFileDownload(response)
        })
        .catch(() => console.log('error occured'))
      },
      forceFileDownload(response){
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'file.pdf') //or any other extension
        document.body.appendChild(link)
        link.click()
      },
    }
  }
</script>

<style lang="scss" scoped>
  .video-responsive {
    position: relative;
    padding-bottom: 56.25%; /* 16/9 ratio */
    padding-top: 30px; /* IE6 workaround*/
    height: 0;
    overflow: hidden;
  }

  .video-responsive iframe,
  .video-responsive object,
  .video-responsive embed {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
</style>
